import { useMutation } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { showErrorToast } from '@hooks/showErrorToast';
import { request } from '@utils';

interface UpdateDeclarantProps {
  declarantIdentificationNumber: string;
}

export const useSendGuaranteeQuery = () => {
  return useMutation({
    mutationFn: async () => {
      await request({
        path: 'declarant/send-guarantee-query',
        method: 'POST',
        authenticate: true,
      });
    },
    onSuccess: () => {
      toast.success('Guarantee query was sent successfully!');
    },
    onError: (error) => {
      showErrorToast(error, `Error sending the Guarantee query!`);
    },
  });
};
